import { render, staticRenderFns } from "./DemoComponent.vue?vue&type=template&id=08df6530"
import script from "./DemoComponent.vue?vue&type=script&lang=js"
export * from "./DemoComponent.vue?vue&type=script&lang=js"
import style0 from "./DemoComponent.vue?vue&type=style&index=0&id=08df6530&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports